/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { useContext, useMemo } from 'react'
import { GridToolbarContainer } from '@mui/x-data-grid';
import {
    Tooltip,
    Button,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    ExpandMoreRoundedIcon,
    TextField,
    IconButton,
    SearchRoundedIcon,
    ClearAllIcon
} from '../../../components/shared/MaterialUI';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import * as Yup from 'yup';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Form, Formik } from 'formik';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';

// @assets
import { toolbarStyles } from '../../../assets/css/customToolbar-styles';

// @helpers
import { FilePageContext } from '../FilePage';
import { MenuItemProps, validateObject } from '../../../helpers/FunctionsUtils';
import { theme } from '../../../assets/theme';
import { GeneralStyles } from '../../../assets/css/general-style';

const CustomToolbar = () => {
    const styles = useMemo(() => toolbarStyles(), []);
    const generalStyle = useMemo(() => GeneralStyles(), []);
    
    const {
        fetchFiles,
        categories,
        filter,
        setFilter
    } = useContext(FilePageContext);

    const handleChange = (e) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        })
    }
    
    const handleChangeDate = (e) => {
        setFilter(prev => ({ ...prev, createdAt:e}))
    }

    const handleClickReload = () => {
        fetchFiles();
    }

    const validationSchemas = Yup.object({
        category: Yup.string().notRequired().nullable(),
        createdAt: Yup.date()
        .nullable()
        .notRequired()
        .typeError('Invalid date, "MM/dd/yyyy" format'),
        errorStatus: Yup.string().notRequired().nullable(),
    });

    const clearSearch = () => {
        const filterHasValue = validateObject(filter);
        if(!filterHasValue)return;
        setFilter({ category: "", createdAt: null, errorStatus: null });
        fetchFiles();
    }

    const handleSubmit = () => {
        const filterHasValue = validateObject(filter);
        if(!filterHasValue)return;
        const params = {
            filters: {
                createdAt: filter.createdAt ? moment(filter.createdAt).format("MM/DD/YYYY") : null,
                category: filter.category,
                errorStatus: filter.errorStatus
            }
        };
        fetchFiles(params);
    }

  return (
    <GridToolbarContainer
        sx={{ ...styles.toolbar, paddingRight: "20px" }}
    >
        <Box sx={{width: '100%'}}>
            <Formik
                initialValues={filter}
                validationSchema={validationSchemas}
                onSubmit={() => {handleSubmit()}}
                enableReinitialize={true}
            >
                {() => {
                    return (
                        <Form autoComplete="off" sx={{width: '100% !important'}}>
                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                spacing={2}
                            >
                                <Grid item xs={12} sm={3} md={2} lg={1.5} >
                                    <h2
                                        style={{
                                            padding: "0px",
                                            margin: "0px",
                                            width: '100%',
                                            color: theme.palette.primary.black
                                        }}
                                    >
                                        File list
                                    </h2>
                                </Grid>

                                <Grid item xs={12} sm={9} md={3} lg={2}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Category</InputLabel>
                                        <Select
                                            id="demo-simple-select"
                                            labelId="demo-simple-select-label"
                                            label="Category"
                                            name='category'
                                            IconComponent={ExpandMoreRoundedIcon}
                                            value={filter.category}
                                            onChange={(e) => {handleChange(e);}}
                                            MenuProps={MenuItemProps}
                                            sx={{ width: '100%', color: theme.palette.secondary.black}}
                                        >
                                            {categories?.map((item, index) => (
                                                <MenuItem
                                                    value={item.id}
                                                    key={index}
                                                >
                                                    {item.category}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={6} md={3} lg={2}>
                                    <FormControl fullWidth sx={{width: '100%'}}>
                                        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={navigator.language}>
                                            <DesktopDatePicker
                                                value={filter.createdAt}
                                                onChange={(date) => {handleChangeDate(date)}}                
                                                allowSameDateSelection={true}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        value={filter.createdAt}
                                                        id="createdAt"
                                                        name="createdAt"
                                                        label="Created At"
                                                        defaultValue={null}
                                                        fullWidth
                                                        sx={generalStyle.input}
                                                    />
                                                )}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={6} md={3} lg={2}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Error status</InputLabel>
                                        <Select
                                            id="demo-simple-select"
                                            labelId="demo-simple-select-label"
                                            label="Error status"
                                            name='errorStatus'
                                            IconComponent={ExpandMoreRoundedIcon}
                                            value={filter.errorStatus}
                                            onChange={(e) => {handleChange(e);}}
                                            MenuProps={MenuItemProps}
                                            sx={{ width: '100%', color: theme.palette.secondary.black}}
                                        >
                                            <MenuItem value={false}> Ok</MenuItem>
                                            <MenuItem value={true}> Errors</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                
                                <Grid item xs={6} sm={3} md={2} lg={3.5} >
                                    <Tooltip title="Search">
                                        <IconButton
                                            type='submit'
                                            sx={{...generalStyle.iconButtonSearch}}
                                        >
                                            <SearchRoundedIcon />
                                        </IconButton>
                                    </Tooltip>
                                    
                                    <Tooltip title="Clear filter">
                                        <IconButton
                                            onClick={() => clearSearch()}
                                            sx={{...generalStyle.iconButtonSearch}}
                                        >
                                            <ClearAllIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>

                                <Grid item xs={6} sm={3} md={2} lg={1} >
                                    <Tooltip
                                        title={<p style={{ fontSize: "16px", margin: "0" }}>Reload state</p>}
                                        arrow
                                    >
                                        <Button
                                            variant="contained"
                                            style={{ backgroundColor: "transparent" }}
                                            children={<CachedOutlinedIcon style={{color: theme.palette.primary.black}} />}
                                            onClick={handleClickReload}
                                        />
                                    </Tooltip>
                                </Grid>
                            </Grid>
                            
                        </Form>
                    )
                }}
            </Formik>
        </Box>
    </GridToolbarContainer>
  )
}

export default CustomToolbar